// extracted by mini-css-extract-plugin
export default {"PrivacyPolicy":"privacy_PrivacyPolicy__V48mk","title":"privacy_title__Y2EAt","warp":"privacy_warp__QMGsj","p1":"privacy_p1__GfQyg","t1":"privacy_t1__rqSFY"};